import axios from "axios";

const TOKEN_KEY = "roadney_admin_token";
const ADMIN_KEY = "roadney_admin";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_KEY));
  } catch {
    return null;
  }
};

export const saveSession = (token, admin) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
};

const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// An expired or tampered token should drop the admin back to the login screen
// instead of leaving the dashboard stuck on a failed request.
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearSession();
      if (window.location.pathname.startsWith("/admin")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;
